import { REACTIONS, ReactionType } from "@/src/models/post.model";
import React from "react";
import { Platform, useWindowDimensions, View } from "react-native";
import ReactionItem from "./reaction-item";

type ReactionPickerProps = Readonly<{
  onSelect: (reaction: ReactionType) => void;
  onClose: () => void;
  onStay?: () => void;
  offset?: { top?: number; bottom?: number; left?: number };
}>;

const ReactionPicker = ({
  onSelect,
  onClose,
  onStay,
  offset,
}: ReactionPickerProps) => {
  const { width } = useWindowDimensions();
  return (
    <View
      className="
        absolute
        flex-row
        items-center
        bg-chalk
        px-1
        py-2
        rounded-3xl
        border
        border-ash-3
        shadow-lg
      "
      style={{
        zIndex: 9999,
        elevation: 10,
        top: offset?.top,
        bottom: offset?.bottom ?? 44,
        left: offset?.left ?? 16,
        // 11 reactions: wrap onto two rows on narrow screens.
        maxWidth: Math.max(240, width - 32),
        flexWrap: "wrap",
        justifyContent: "center",
      }}
      pointerEvents="auto"
      {...(Platform.OS === "web"
        ? {
            onMouseEnter: onStay as any,
            onMouseLeave: onClose as any,
          }
        : {})}
    >
      {REACTIONS.map((reaction) => (
        <ReactionItem
          key={reaction.id}
          id={reaction.id}
          emoji={reaction.emoji}
          onSelect={onSelect}
        />
      ))}
    </View>
  );
};

export default ReactionPicker;
